import { main_phaser } from "./MadnesApp";
import * as MV from "./madnes_variables";
import {
	madnes_objects,
	sprite_sizes,
	quality,
	forcestopnow,
	forcestop_enable,
} from "./madnes_variables";
import events from "../../events/EventsObservable";
import { EVENTS } from "../../events/baseEvents";
import { GAME_EVENTS } from "../../game/gameEvents";
import { WALLET_EVENTS } from "../../wallet/Wallet";
import { win_anim_skip_click } from "./madnes_variables";
import { set_win_anim_skip_click } from "./madnes_variables";
import { CONFIG_PARAMS } from "../../system/SystemConfig";
import { ACTION_EVENTS } from "../../ui/UserAction";
import { wi_scale } from "./madnes_variables";
import { he_scale } from "./madnes_variables";
import { set_forcestopnow } from "./madnes_variables";
import { madnes_adapter } from "./madnes_variables";
import { REELS_EVENTS } from "../../game/slot/reelsEvents";
import { screen } from "./madnes_variables";
import { big_win } from "./madnes_variables";
import { mega_win } from "./madnes_variables";
import { super_win } from "./madnes_variables";
import { set_behavior_config } from "./madnes_variables";

export const MADNES_CONFIG = {
	paths: {
		symbols: "assets/img/symbols/",
	},
};

export let win = 0;
export let bet = 10;
export let coin_val = 1;
export let lines_count = 1;

export function notify(eventName, data) {
	switch (eventName) {
		case WALLET_EVENTS.WALLET_ON_SET_BALANCE:
		case WALLET_EVENTS.WALLET_ON_SET_BET:
			win = data.win;
			bet = madnes_money_to_coin(data.atomicBet);

			if (data.linesCount) {
				lines_count = data.linesCount;
			}

			coin_val = data.coinValue;
			// console.log(data.win, data.atomicBet);
			break;

		case WALLET_EVENTS.WALLET_ON_SET_WIN:
			win = data.win;
			break;

		case GAME_EVENTS.GAME_END_ROUND:
			set_win_anim_skip_click(false);
			set_forcestopnow(false);
			break;
	}
}

export function registerAdapter(adapter) {
	MV.set_madnes_adapter(adapter);
}

export function register({
	config,
	commander,
	game,
	wallet,
	statesManager,
	screen,
}) {
	MV.set_systemConfig(config);
	MV.set_commander(commander);
	MV.set_game(game);
	MV.set_wallet(wallet);
	MV.set_states(statesManager);
	MV.set_screen(screen);
}

export function initApp() {
	MV.set_quality(calc_quality(MV.systemConfig.get(CONFIG_PARAMS.QUALITY)));
}

/**
 * @param {Settings} settings
 */
export function onServerPreInit(settings) {
	set_behavior_config(settings.getBehavior());

	let minBigWinFac = settings.getMinBigWinFactor() || 25;
	let minMegaWinFac = settings.getMinMegaWinFactor() || 50;
	let minSuperWinFac = settings.getMinSuperMegaWinFactor() || 125;

	madnes_set_win_factors(minBigWinFac, minMegaWinFac, minSuperWinFac);
}

/**
 * @param {InitResult} initResult
 */
export function onServerInit(initResult) {
	let data = initResult.getData();
	MV.set_server_config(data);
	MV.set_picture_convert(data);
}

export async function madnes_set_win(win = 0) {
	await MV.wallet.setWinAsync(win);
}

export async function madnes_add_win(win = 0) {
	await MV.wallet.setWinAsync(MV.wallet.getWin() + win);
}

// /**
//  * @param {?number} atomicBet
//  * @return {number}
//  */
// export function madnes_get_real_bet(atomicBet = undefined) {
//     return MV.wallet.getRealBet(atomicBet);
// }

export function madnes_get_atomic_bet() {
	return MV.wallet.getBet();
}

export function madnes_get_game_specifics() {
	return MV.systemConfig.getGameSpecifics(MV.wallet.isBonus());
}

export function madnes_get_money_bet(b = bet, linesCount = lines_count) {
	return MV.wallet.creditToMoney(b) * linesCount;
}

export function madnes_money_to_coin(money) {
	return madnes_money_to_credit(money);
}

export function madnes_money_to_credit(money) {
	return MV.wallet.moneyToCredit(money);
}

export function madnes_money_to_credit_decimals(money) {
	return MV.wallet.moneyToCreditWithDecimals(money);
}

export function madnes_credit_to_money(credit) {
	return MV.wallet.creditToMoney(credit);
}

export function madnes_get_fs_count() {
	return madnes_get_fs_total();
}

export function madnes_get_fs_total() {
	return MV.game.freespins.getFreeSpinNumber();
}

export function getUrl(url, config = MV.systemConfig) {
	url = url.replace("{l}", getLanguage(config));
	return url.replace("{q}", MV.quality);
}

export function madnes_is_in_freespins() {
	return MV.game.freespins.isInFreeSpins();
}

export function getLanguage(config = MV.systemConfig) {
	let lang = config.get(CONFIG_PARAMS.LANGUAGE);

	if (madnes_adapter.infotexts_languages.includes(lang)) {
		return lang;
	}

	return config.get(CONFIG_PARAMS.DEF_LANG);
}

export function madnes_new_round() {
	MV.game.start();
}

// export function madnes_end_round(ended = true, roundData = {}, fsData = {}, callback = () => {}) {
//
//     let params = roundData ? {
//         fsWin: fsData.fsWin,
//         fsOrder: fsData.fsOrder,
//         fsCount: fsData.fsCount
//     } : {};
//
//     MV.game.endRound(params).then(callback);
// }

export function madnes_fullscreen_disable() {
	screen.gameplayDisableFullscreen();
}

export function madnes_fullscreen_enable() {
	screen.gameplayEnableFullscreen();
}

export function madnes_end_round() {
	return MV.commander.endRound();
}

/**
 * @param {string} q
 * @return {number}
 */
export function calc_quality(q) {
	if (q !== "h") return 50;
	return 100;
}

export function set_sprite(name, w, h) {
	sprite_sizes.push({
		name: name,
		wi: Math.floor(w / (100 / quality)),
		he: Math.floor(h / (100 / quality)),
	});
}

export function set_ico_size(wi, he) {
	MV.set_ico_wi(wi);
	MV.set_ico_he(he);
}

export function madnes_set_win_factors(big, mega, supermega) {
	MV.set_big_win(big);
	MV.set_mega_win(mega);
	MV.set_super_win(supermega);
}

export function madnes_set_input_up(name, func) {
	madnes_objects[name].inputEnabled = true;
	madnes_objects[name].events.onInputUp.add(func, this);
}

export function madnes_set_input_down(name, func) {
	madnes_objects[name].inputEnabled = true;
	madnes_objects[name].events.onInputDown.add(func, this);
}

export function madnes_set_hand_cursor(name, bool) {
	madnes_objects[name].inputEnabled = true;
	madnes_objects[name].input.useHandCursor = bool;
}

export function madnes_get_json(name) {
	return main_phaser.cache.getJSON(name);
}

export function madnes_forcestopnow() {
	return forcestopnow && forcestop_enable;
}

export function madnes_get_currtime() {
	if (
		typeof main_phaser != "undefined" &&
		typeof main_phaser.time != "undefined" &&
		typeof main_phaser.time.now != "undefined"
	) {
		return main_phaser.time.now;
	} else {
		return 0;
	}
}

export function madnes_microtime(get_as_float) {
	var now = new Date().getTime() / 1000;
	var s = parseInt(now, 10);
	return get_as_float ? now : Math.round((now - s) * 1000) / 1000 + " " + s;
}

export function madnes_join(a1, a2) {
	return a1.concat(a2);
}

export function madnes_fill_range(from, to) {
	var ret = [];
	for (var i = from; i <= to; i++) {
		ret[ret.length] = i;
	}
	return ret;
}

export function madnes_reverse(a) {
	var ret = [];
	for (var i = a.length - 1; i >= 0; i--) {
		ret[ret.length] = a[i];
	}
	return ret;
}

export function madne_is_number(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

export function madnes_angle_between(x1, y1, x2, y2) {
	return Phaser.Math.angleBetween(x1, y1, x2, y2);
}

export function madnes_distance(x1, y1, x2, y2) {
	return Phaser.Math.distance(x1, y1, x2, y2);
}

export function madnes_rad_to_deg(rad) {
	return Phaser.Math.radToDeg(rad);
}

export function madnes_deg_to_rad(deg) {
	return Phaser.Math.degToRad(deg);
}

export function madnes_eval(func) {
	if (typeof func === "undefined") {
		return;
	}

	if (typeof func === "string") {
		eval(func);
	} else {
		func();
	}
}

export function madnes_win_anim_skip() {
	if (
		win_anim_skip_click
		// && server_config.behavior.animation.winLines.skipAnimCount <= madnes_win_anim_count
	) {
		return true;
	}
	return false;
}

export function madnes_win_anim_reset() {
	set_win_anim_skip_click(false);
}

export function madnes_is_in_autostart() {
	return false;
	// return MV.game.isAutoRun();
	// return !!autostart;
	//return autostart * 1 > 0 || autostart == "∞";
}

export function madnes_rotate_start() {
	events.dispatch(EVENTS.SPIN);
}

//
// export function madnes_show_stop() {
//
// }

export function madnes_set_sprite(name, w, h) {
	set_sprite(name, w, h);
}

// PIXI.blendModes
export function madnes_set_blend_mode(name, mode) {
	madnes_objects[name].blendMode = mode;
}

export function madnes_get_mouse_x() {
	return main_phaser.input.worldX / wi_scale;
}

export function madnes_get_mouse_y() {
	return main_phaser.input.worldY / he_scale;
}

export function madnes_get_mouse() {
	return [madnes_get_mouse_x(), madnes_get_mouse_y()];
}

/**
 * @param {number} color1
 * @param {number} color2
 * @param {number} steps
 * @param {number} currentStep
 * @param {number=} alpha
 */
export function madnes_interpolate_color(
	color1,
	color2,
	steps,
	currentStep,
	alpha
) {
	if ((currentStep | 0) === 0) {
		currentStep = 1; //color fix
	}

	return Phaser.Color.interpolateColor(
		color1,
		color2,
		steps,
		currentStep | 0,
		alpha
	);
}

export function madnes_random_angle() {
	return main_phaser.rnd.angle();
}

export function madnes_circle_rand_point(radius) {
	var angle = Math.random() * Math.PI * 2;
	return {
		x: Math.cos(angle) * radius,
		y: Math.sin(angle) * radius,
	};
}

export function madnes_circle_rand_inner_point(x, y, diameter) {
	//return new Phaser.Circle(x, y, diameter).random(new Phaser.Point());

	var t = 2 * Math.PI * Math.random();
	var u = Math.random() + Math.random();
	var r = u > 1 ? 2 - u : u;

	return {
		x: x + r * diameter * Math.cos(t),
		y: y + r * diameter * Math.sin(t),
	};
}

export function madnes_set_pivot(name, x, y) {
	madnes_objects[name]["pivot"]["x"] = x;
	madnes_objects[name]["pivot"]["y"] = y;
}

export function madnes_time_event_add(func, time) {
	return main_phaser.time.events.add(time, func);
}

export function madnes_time_event_loop(func, time) {
	return main_phaser.time.events.loop(time, func);
}

export function madnes_time_event_stop(timerEvent) {
	main_phaser.time.events.remove(timerEvent);
}

export function madnes_check_focus() {
	return document.hasFocus() ? true : false;
}

export function madnes_start_freespins() {
	events.dispatch(GAME_EVENTS.GAME_ENTER_FREESPINS);
}

export function madnes_end_freespins() {}

export function madnes_spin_start() {
	events.dispatch(GAME_EVENTS.GAME_SPIN_START);
}

export function madnes_spin_end() {
	events.dispatch(GAME_EVENTS.GAME_SPIN_END);
}

export function madnes_reels_start() {
	events.dispatch(REELS_EVENTS.REELS_START);
}

export function madnes_reels_stop() {
	events.dispatch(REELS_EVENTS.REELS_COMPLETE);
}

export function madnes_is_big_win(win, atomicCreditBet) {
	return win > madnes_credit_to_money(atomicCreditBet) * lines_count * big_win;
}

export function madnes_is_mega_win(win, atomicCreditBet) {
	return win > madnes_credit_to_money(atomicCreditBet) * lines_count * mega_win;
}

export function madnes_is_super_mega_win(win, atomicCreditBet) {
	return (
		win > madnes_credit_to_money(atomicCreditBet) * lines_count * super_win
	);
}
